module.exports = __webpack_public_path__ + "img/table-kitchen-pc.5aaf5245.png";